import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import { Nav, Tab } from "react-bootstrap";
import Repeatability_Report from "./inner_tab_reports/repeatability_report/Repeatability_Report";
import Reproducibility_Report from "./inner_tab_reports/reproducibility_report/Reproducibility_Report";
import Accuracy_Report from "./inner_tab_reports/accuracy_report/Accuracy_Report";

const Process_Requirement = () => {
  const [show, setShow] = useState(false);

  const tabs = [
    "Repeatability Report",
    "Reproducibility Report",
    "Accuracy Report",
  ];

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Resource Requirement" />
      </div>

      <div className="tables_tab_section">
        <Tab.Container id="left-tabs-example" defaultActiveKey={tabs[0]}>
          <Nav variant="pills" className="">
            {tabs?.map((item) => {
              return (
                <Nav.Item>
                  <Nav.Link eventKey={item}>{item}</Nav.Link>
                </Nav.Item>
              );
            })}
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Repeatability Report">
              <Repeatability_Report />
            </Tab.Pane>
            <Tab.Pane eventKey="Reproducibility Report">
              <Reproducibility_Report />
            </Tab.Pane>
             <Tab.Pane eventKey="Accuracy Report">
              <Accuracy_Report />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>

      <Common_Report_Offcanvas
        title={"Resource Requirement"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Process_Requirement;
